import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'

export default class extends Controller {
  static targets = ['field', 'form']

  connect() {
    this.slimSelect = new SlimSelect({
      select: this.fieldTarget,
      settings: {
        showSearch: false,
      },
      events: {
        afterChange: () => {
          this.submitForm();
        }
      }
    });

    // Check if removing ss-selected class is enabled
    if (this.hasRemoveSelectedClass) {
      this.removeSelectedClass();
      this.removeBorder();
    }
  }

  removeSelectedClass() {
    document.querySelectorAll('.ss-selected').forEach(element => {
      element.classList.remove('ss-selected');
    });
  }

  removeBorder() {
    document.querySelectorAll('.ss-main').forEach(element => {
      element.style.border = '0px';
    });
  }

  submitForm() {
    this.formTarget.requestSubmit();
  }

  get hasRemoveSelectedClass() {
    return this.element.dataset.slimRemoveSelectedClass === "true";
  }
}
